import React, { useEffect, useState } from "react";
import CartIcon from "./CartIcon";
import SearchIcon from "./SearchIcon";
import LoggedOutUser from "./LoggedOutUser";
import User from "./User";
import { ModalType}  from "../types";
import MenuIcon from "@wantable/Shared/src/components/Icons/MenuIcon";

export interface MobileNavProps {
  isLoggedIn: boolean;
  cartItemsAmount: number;
  wishlistItemsAmount: number;
  openedModal: ModalType;
  isMobile: boolean;
  hidden: boolean;
  onAfterLogin?: () => void;
  onLogout: () => void;
  openModal: () => void;
  handleLogin(): void;
}

const MobileNav = (props: MobileNavProps) => {

  return (
      <nav id="mobile-nav" className={`${props.hidden ? '' : 'hidden'} w-full inline-flex h-60 items-center relative pl-[16px] pr-[10px] md:pl-[31.5px] md:pr-[35.5px] bg-white`}>
        <div className="nav-inner w-full relative flex p-4 items-center justify-between">
          <button id="menu-btn" aria-label="Menu Button" type="button" className="btn slide-menu__control" data-target="slide-menu" data-action="toggle">
            <MenuIcon className={"h–40 w-40"} />
          </button>

          <div className="logo">
            {window && window.WANTABLE_header.logo && (
              <>
              <a
                href={window.WANTABLE_header.homepageLink}
                className="flex absolute left-1/2 top-1/2 -mt-[17.5px] md:-mt-20 -ml-[17.5px] md:-ml-[103.5px] hidden md:block"
              >
                <img
                  className="h-[40px]"
                  src={window.WANTABLE_header.logo}
                  alt="wantable logo"
                />
              </a>
              <a
                href={window.WANTABLE_header.homepageLink}
                className="flex relative hidden xs:max-md:block"
              >
                <img
                  className="h-[34px]"
                  src={window.WANTABLE_header.logo}
                  alt="wantable logo"
                />
              </a>
              </>
            )}

            {window && window.WANTABLE_header.mobileLogo && (
              <a
                href={window.WANTABLE_header.homepageLink}
                className="flex relative w-[34px] block xs:hidden"
              >
                <img
                  className="h-full"
                  src={window.WANTABLE_header.mobileLogo}
                  alt="wantable mobile logo"
                />
              </a>
            )}
          </div>

          <div className="icons flex">
            {props.isLoggedIn ? (
              <User className={"w-32 h-32"} isLoggedIn={props.isLoggedIn} isMobile={props.isMobile} onLogout={props.onLogout} />
            ) : (
              <LoggedOutUser isDesktop={false} onLogin={props.handleLogin} />
            )}

            <button name="search" aria-label="Search Icon" className="h–32 w-32 flex justify-center items-center">
              <SearchIcon className="w-32 h-32" />
            </button>

            {props.isLoggedIn && (
              <div className="flex justify-center items-center relative wk-ref">
              </div>
            )}

            <button name="cart" aria-label="Cart Icon" className="h–32 flex justify-center items-center relative" data-testid="cart-button">
              <CartIcon className="w-32 h-32"/>
              {props.cartItemsAmount > 0 && (
                <p className="absolute -top-6 -right-2 font-bold text-[12px] core-peach">
                  {props.cartItemsAmount}
                </p>
              )}
            </button>
          </div>
        </div>
      </nav>
  )
}

export default MobileNav
